import { Button, Modal, Col, Row, message } from 'antd'
import { ExclamationCircleOutlined } from '@ant-design/icons'
import React, { useState } from 'react'
import { changeUserStatus } from '../../../../api/api'
import './index.css'
const UserCheckModal = (props) => {
  const [isModalOpen, setIsModalOpen] = useState(false)
  const info = props.userDetail
  const setIsFresh = props.setIsFresh
  // console.log("user info",info);
  const showModal = () => {
    setIsModalOpen(true)
  }

  const handleOk = () => {
    setIsModalOpen(false)
    const params = { ids: [info.id], is_membership: 1 }
    changeUserStatus(params).then((res) => {
      console.log(res)
      setIsFresh((pre) => {
        return !pre
      })
    })
    message.success('会员审核通过')
  }

  const handleCancel = (e) => {
    setIsModalOpen(false)
    const target = String(e.target)
    // console.log("JSON",e.target);
    // console.log(e.target.classList.contains('ant-modal-close-x'))
    // console.log(
    //   target,
    //   target.indexOf('SVG'),
    //   target.indexOf('ant-modal-close-x')
    // )
       if (
         target.indexOf('SVG') !== -1 ||
         e.target.classList.contains('ant-modal-close-x')
       ) {
         //点击x或者按键盘esc关闭的弹窗
         console.log('this is close!')
         return
       } else {
         const params = { ids: [info.id], is_membership: 0 }
         changeUserStatus(params).then((res) => {
           console.log(res)
           setIsFresh((pre) => {
             return !pre
           })
         })
         message.success('取消会员成功')
       }

  }

  const confirm = () => {
    Modal.confirm({
      title: '确认取消会员吗？',
      icon: <ExclamationCircleOutlined />,
      content: '',
      okText: '确认',
      cancelText: '取消',
    })
  }
  return (
    <>
      <a onClick={showModal}>
        {info.is_membership === 0 ? '通过会员' : '取消会员'}
      </a>
      <Modal
        title="申请信息"
        open={isModalOpen}
        onOk={handleOk}
        onCancel={handleCancel}
        okText="通过会员"
        cancelText="取消会员"
        maskClosable={false}
      >
        <div class="parent">
          <div class="left">
            <div>
              <span>姓名：</span>
            </div>
            <div>
              <span>华威学院：</span>
            </div>
            <div>
              <span>就读专业：</span>
            </div>
            <div>
              <span>年级：</span>
            </div>
            <div>
              <span>联系邮箱：</span>
            </div>
            <div>
              <span>微信号：</span>
            </div>
          </div>
          <div class="right">
            <div>
              <span>{info.name}</span>
            </div>
            <div>
              <span>{info.college}</span>
            </div>
            <div>
              <span>{info.major}</span>
            </div>
            <div>
              <span>{info.grade}</span>
            </div>
            <div>
              <span>{info.email}</span>
            </div>
            <div>
              <span>{info.wechat}</span>
            </div>
          </div>
        </div>
      </Modal>
      {/* <a onClick={confirm}>
        取消会员
      </a> */}
    </>
  )
}
export default UserCheckModal
